import React, {Component} from 'react';
import toast from 'react-hot-toast';


const Wait = () => toast.loading('Espere...', { duration: 4000, position: 'top-center'});

class Form extends Component {
    state = {
        name: '',
        apellido: '',
        email: '',
        number: '',
        message: '',
        emailStatus: '',
    };

    // handle the value
    handleCHange = input => e => {
        this.setState({[input]: e.target.value});
    }

    // when submit btn is clicked
    submitForm = (e) => {
        const {name, apellido, email, number, message} = this.state;
        
        

        // create a new XMLHttpRequest
        var xhr = new XMLHttpRequest();
    
        // get a callback when the server responds
        xhr.addEventListener('load', () => {
            // update the response state and the step
            toast.success('Mensaje enviado con Exito')
        });
        // open the request with the verb and the url
        xhr.open('POST', 'https://estanciamargarita.com.ar/backend/index.php?sendto=' 
                                         + email + 
                                '&name=' + name + 
                                '&apellido=' + apellido +
                                '&number=' + number +
                                '&message=' + message);
                                
        // send the request
        xhr.send(
            toast.loading('Espere...', { duration: 4000, position: 'top-center'})
        );

        // reset the fields
        this.setState({
            name: '',
            apellido: '',
            email: '',
            message: '',
            number: '',
        });
        e.preventDefault();
    }

    render(){
        const {name, apellido, email, message, number, emailStatus} = this.state;
        return(
            
            <div >
             <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3281.433254802001!2d-58.97080992520888!3d-34.66901326094787!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bc8c2ba4de3b39%3A0xbd36cbaca2036f06!2sEstancia%20La%20Margarita!5e0!3m2!1ses!2sar!4v1715353126616!5m2!1ses!2sar" className="relative block h-32 lg:col-span-2 lg:h-full w-full"  loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
           
            </div>


        );
    }
}

export default Form;